import { Grow, Typography, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TooltipRenderProps } from "react-joyride";
import {
  TooltipCard,
  CustomCardContent,
  CloseButton,
  CustomCardActions,
  CardActionsButtons,
} from "./GuidedTourTooltip.styles";
import { useState } from "react";
import { SubmitButton } from "@avenue-8/sidekick-ui";

export const GuidedTourTooltip = ({
  index,
  step,
  tooltipProps,
  primaryProps,
  backProps,
  skipProps,
  size,
}: TooltipRenderProps) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Grow in key={index} timeout={300}>
      <TooltipCard {...tooltipProps}>
        <CustomCardContent>
          <Typography variant="h5">{step.title}</Typography>
          <Typography variant="body2">{step.content}</Typography>
          <CloseButton {...skipProps}>
            <CloseIcon />
          </CloseButton>
        </CustomCardContent>
        <CustomCardActions>
          <CardActionsButtons>
            {step.showSkipButton && (
              <Button color="secondary" variant="text" {...skipProps}>
                skip
              </Button>
            )}
            {!step.hideBackButton && index > 0 && (
              <Button variant="text" {...backProps}>
                Back
              </Button>
            )}
            <SubmitButton
              {...primaryProps}
              onClick={(e) => {
                primaryProps.onClick(e);
                setIsLoading(true);
              }}
              isLoading={isLoading}
            >
              {index + 1 === size ? "Finish" : "Next"} {index + 1}/{size}
            </SubmitButton>
          </CardActionsButtons>
        </CustomCardActions>
      </TooltipCard>
    </Grow>
  );
};
